import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { HowToUseSection } from '../components/HowToUseSection';
import { ProductDetailsSection } from '../components/ProductDetailsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
import { StickyCTA } from '../components/StickyCTA';
import { useMetaPixel } from '../hooks/useMetaPixel';
export function SalesPage() {
  useMetaPixel();
  return <main className="min-h-screen w-full overflow-x-hidden" data-id="element-323">
      <HeroSection data-id="element-324" />
      <ProblemSection data-id="element-325" />
      <SolutionSection data-id="element-326" />
      <HowToUseSection data-id="element-327" />
      <ProductDetailsSection data-id="element-328" />
      <TestimonialsSection data-id="element-329" />
      <FAQSection data-id="element-330" />
      <Footer data-id="element-331" />
      <StickyCTA data-id="element-332" />
    </main>;
}